/**
 * Pinia Stores 入口文件
 * 统一管理所有的 Pinia stores
 */

import { createPinia } from 'pinia'
import { useUserStore } from './user'
import { useSchoolStore } from './school'
// 在文件顶部导入新的store
import { useHomeworkStore } from './homework'

// 创建 Pinia 实例
const pinia = createPinia()

// 开发环境下添加调试插件
if (process.env.NODE_ENV === 'development') {
  // 可以在这里添加其他开发环境的调试功能
  console.log('Pinia stores initialized in development mode')
}

// 可选：添加 Pinia 插件
// 例如持久化插件
try {
  // 如果需要持久化插件，可以在这里添加
  // import { createPersistedState } from 'pinia-plugin-persistedstate'
  // pinia.use(createPersistedState())
} catch (error) {
  console.log('Pinia 插件加载可选，跳过')
}

// 导出 Pinia 实例
export default pinia

// 导出所有 stores
export {
  useUserStore,
  useSchoolStore,
  useHomeworkStore // 添加新store
}

// 便捷的 stores 对象
const stores = {
  user: useUserStore,
  school: useSchoolStore,
  homework: useHomeworkStore // 添加新store
}

/**
 * 获取所有 stores 的辅助函数
 * 在组件外部使用时很有用
 */
export const getStores = () => {
  return {
    user: useUserStore(),
    school: useSchoolStore()
  }
}

/**
 * 重置所有 stores 的辅助函数
 * 用于登出或重置应用状态
 */
// 添加到 storeMap 和 resetAllStores 函数中
export function resetAllStores() {
  const userStore = useUserStore()
  const schoolStore = useSchoolStore()
  const homeworkStore = useHomeworkStore() // 添加新store
  
  userStore.logout()
  schoolStore.resetState()
  homeworkStore.resetState() // 重置作业store
}

// 在 getDefaultState 函数中添加
export function getDefaultState() {
  return {
    user: useUserStore(),
    school: useSchoolStore()
  }
}

/**
 * 初始化所有 stores 的辅助函数
 * 用于应用启动时的初始化
 */
export const initializeAllStores = async () => {
  const userStore = useUserStore()
  const schoolStore = useSchoolStore()
  
  userStore.initializeUserState()
  
  // 如果用户已登录，优先从缓存加载学校列表
  if (userStore.isLoggedIn) {
    // 首先尝试从缓存加载
    if (!schoolStore.loadFromLocalStorage()) {
      // 缓存无效时从服务器获取
      await schoolStore.fetchSchoolList()
    }
  }
  
  // 如果有其他 stores 需要初始化，也可以在这里调用
}